exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".static-header-layout .content-body{padding-top:50px;padding-bottom:50px}@media only screen and (max-width:929px){.static-header-layout .content-body{padding-top:20px;padding-bottom:20px}}", ""]);

// exports
